import { render, staticRenderFns } from "./AdsTextArea.vue?vue&type=template&id=a25426a0&scoped=true&"
import script from "./AdsTextArea.vue?vue&type=script&lang=js&"
export * from "./AdsTextArea.vue?vue&type=script&lang=js&"
import style0 from "./AdsTextArea.vue?vue&type=style&index=0&id=a25426a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25426a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
